export const hideScrollBarStyles = {
  '::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarGutter: 'stable both-edges',
  scrollbarWidth: 'none',
};
